import { render, staticRenderFns } from "./SpecialOfferItemRight.vue?vue&type=template&id=0ecb5078&scoped=true&"
import script from "./SpecialOfferItemRight.vue?vue&type=script&lang=js&"
export * from "./SpecialOfferItemRight.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOfferItemRight.vue?vue&type=style&index=0&id=0ecb5078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb5078",
  null
  
)

export default component.exports